import { cookieNames, deleteCookie, getCookie } from "../../utils/cookies"
import { DELIVERY_SETTINGS_PICKER_COOKIE } from "../screens/settings/deliverySettings/utils"

export const getCookieSession = () => getCookie(cookieNames.session)

export const getCookieUserId = () => getCookie(cookieNames.userId)

export const getCookieUserEmail = () => getCookie(cookieNames.userEmail)

export const getCookieUserRole = () => getCookie(cookieNames.userRole)

export const getCookieAccountId = () => getCookie(cookieNames.accountId)

export const getCookieLocationId = () => getCookie(cookieNames.locationId)

export const getCookieLocationOverrideId = () => getCookie(cookieNames.overrideLocationId)

export const getCookieOrganizationId = () => getCookie(cookieNames.organizationId)

export const getCookieDeliverySettingsSelectedServiceId = () => getCookie(DELIVERY_SETTINGS_PICKER_COOKIE)

export const deleteAllCookies = () => {
    for (const name of Object.values(cookieNames)) {
        deleteCookie(name)
    }
    deleteCookie(DELIVERY_SETTINGS_PICKER_COOKIE)
}
